var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanySmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H5.06773L20.5767 20.6423L5.06773 41.2627H0L15.509 20.6423L0 0Z",
    fill: "#2AC4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7894 0H32.7217L20.0742 16.8196L22.6081 20.1835L37.7894 0ZM20.0742 24.443L32.7217 41.2627H37.7894L22.6081 21.0791L20.0742 24.443Z",
    fill: "#202A5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2109 0H17.2787L32.7877 20.6423L17.2787 41.2627H12.2109L27.7199 20.6423L12.2109 0Z",
    fill: "#2AC4EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0004 0H44.9326L32.2852 16.8196L34.819 20.1835L50.0004 0ZM32.2852 24.443L44.9326 41.2627H50.0004L34.819 21.0791L32.2852 24.443Z",
    fill: "#202A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySmallLogo);
export default __webpack_public_path__ + "static/media/company-small-logo.f53720d98e77d30ea04444094a099013.svg";
export { ForwardRef as ReactComponent };